module.exports = __webpack_public_path__ + "img/pdf_logo.fb67f564.png";